/**
 * 身分作用域（client only）：
 * 1. 安裝 Pinia plugin：提供 `resetUserScoped()` 的 store 一建立就自動註冊，換帳號 / 登出時統一重置。
 * 2. 換帳號後重抓獎勵清單，讓畫面回到目前帳號。
 * 規格見 spec/2026-10-19-reward-claim-identity-scope/design.md §5.4。
 *
 * 檔名以 00. 開頭：必須早於任何 user-scoped store 的第一次建立，否則該 store 不會被註冊。
 */

import { watch } from 'vue'

import { useIdentityScopeStore } from '@/stores/auth/identityScope'

export default defineNuxtPlugin((nuxtApp) => {
  const identityScope = useIdentityScopeStore()

  // 約定：store 提供 resetUserScoped() 即代表它持有「屬於某個帳號」的資料（design §5.4）
  nuxtApp.$pinia.use(({ store }) => {
    if (typeof store.resetUserScoped === 'function') {
      identityScope.registerUserScopedStore(store)
    }
  })

  const stop = watch(
    () => identityScope.uidSite,
    (nextUidSite, previousUidSite) => {
      // 只處理「A → B」：首次登入由 main.vue 的登入流程抓清單，登出（→ null）不需要抓
      if (!previousUidSite || !nextUidSite || previousUidSite === nextUidSite) return

      // useReward 依賴 $request（01.request.js 才提供），且 watch callback 已離開 Nuxt context，
      // 故在此時才於 context 內建立
      nuxtApp.runWithContext(() => {
        // 背景重抓：吞掉 rejection，真實錯誤已於 request 層上報，失敗等下一輪輪詢
        useReward()
          .fetchRewardList()
          .catch(() => {})
      })
    }
  )

  // client plugin 的 watch 與整個 app 同生命週期；dev HMR 重載本檔時才需要清理
  if (import.meta.hot) {
    import.meta.hot.dispose(stop)
  }
})
